import React, { useContext, useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ContextSheet } from '../../Context/SheetContext';

function CheckBoxWrapper() {

  const valueSheet = useContext(ContextSheet);

  const handleChange = (event) => {
    valueSheet.setChecked(event.target.checked);
  };


  return (
    <FormGroup>
      <FormControlLabel control={<Checkbox checked={valueSheet.checked} onChange={handleChange} />} label="InActive" />

    </FormGroup>
  );
}
export default CheckBoxWrapper;